import React from 'react'
import dayjs from 'dayjs'
import styles from './MomiStatusBadge.module.scss'
import { useMomiStatus } from '../../hooks/useMomiStatus'

interface MomiStatusBadgeProps {
  momiId?: string
  showLastSeen?: boolean
}

export default function MomiStatusBadge({
  momiId,
  showLastSeen = true,
}: MomiStatusBadgeProps) {
  const { data, isLoading } = useMomiStatus(momiId)

  if (!momiId) return null
  if (isLoading || !data) {
    return (
      <span className={[styles.badge, styles.unknown].join(' ')}>
        <span className={[styles.dot, styles.dotUnknown].join(' ')} />
        Statut MoMi…
      </span>
    )
  }

  const isOnline = data.status === 'online'
  const isOffline = data.status === 'offline'
  const wrapperClass = isOnline
    ? styles.online
    : isOffline
      ? styles.offline
      : styles.unknown
  const dotClass = isOnline
    ? styles.dotOnline
    : isOffline
      ? styles.dotOffline
      : styles.dotUnknown
  const label = isOnline
    ? 'MoMi en ligne'
    : isOffline
      ? 'MoMi hors ligne'
      : 'MoMi statut inconnu'

  return (
    <span className={[styles.badge, wrapperClass].join(' ')}>
      <span className={[styles.dot, dotClass].join(' ')} />
      {label}
      {showLastSeen && data.last_seen && (
        <span className={styles.lastSeen}>
          (vu {dayjs(data.last_seen).format('DD/MM HH:mm')})
        </span>
      )}
    </span>
  )
}
